/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown>, percent: NonNullable<unknown> }} Plan_Tab_Token_Pool_OfInputs */



/**
* | output |
* | --- |
* | "of €{total} ({percent}%)" |
*
* @param {Plan_Tab_Token_Pool_OfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_token_pool_of = /** @type {((inputs: Plan_Tab_Token_Pool_OfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Token_Pool_OfInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`von €${i?.total} (${i?.percent}%)`)
	return /** @type {LocalizedString} */ (`of €${i?.total} (${i?.percent}%)`)
});